import { func, string } from 'prop-types';
import React, { Component } from 'react';

import ActiveView from '../../associations/Association/ActiveView';

class ListSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { listIds: [] };
    this.onChange = this.onChange.bind(this);
  }

  onChange({ target: { value, name } }) {
    this.setState({ [name]: value }, () => {
      this.props.onChange({ listIds: this.state.listIds });
    });
  }

  render() {
    const { type } = this.props;
    return (
      <div className="d-flex w-100">
        <ActiveView
          widthClassName="w-100"
          selectClassName="w-inherit"
          className="m-select--small list-select"
          type={type}
          name="listIds"
          onSelectBlur={() => {}}
          isMulti
          hideAddButton
          onChange={this.onChange}
          minSearchLength={1}
        />
      </div>
    );
  }
}

ListSelect.propTypes = {
  onChange: func.isRequired,
  type: string.isRequired,
};

export default ListSelect;
